import AppealsDetailSection from '../../../sections/AdminDashboard/Configuration/AppealsDetail';

const AppealsDetail = () => <AppealsDetailSection />;

export default AppealsDetail;
